import type { FilterDropdownOption } from '~/components/filter/FilterDropdown.vue'
import { SKELETONS_PER_PAGE_LARGE_GRID, SKELETONS_PER_PAGE_SMALL_GRID } from '~/configuration/global.configuration'

export function useProductGridOptions() {
  const { $t } = useNuxtApp()

  const selectedGridOptionValue = useState('selectedGridOption', () => 'default')
  const gridOptions = ref<FilterDropdownOption[]>([
    { label: $t('gridDefault'), value: 'default', icon: 'grid' },
    { label: $t('gridImagesOnly'), value: 'image-only', icon: 'grid-small' },
  ])
  const selectedGridOption = computed<FilterDropdownOption>(() => gridOptions.value.find(o => o.value === selectedGridOptionValue.value) || gridOptions.value[0])

  function selectGridOption(option: FilterDropdownOption) {
    selectedGridOptionValue.value = option.value
    window.scrollTo({ top: 0, behavior: 'instant' })
  }

  const smallGrid = computed(() => {
    return selectedGridOption.value.value === 'image-only'
  })

  const numberOfCards = computed(() => {
    const gridDependentNumber = smallGrid.value ? SKELETONS_PER_PAGE_SMALL_GRID : SKELETONS_PER_PAGE_LARGE_GRID
    const number = Array.from({ length: gridDependentNumber }, (_, i) => i)
    return [...number]
  })

  return {
    gridOptions,
    selectedGridOption,
    selectGridOption,
    smallGrid,
    numberOfCards,
  }
}
